import styled from "styled-components"
import { ShowCount } from "../../../../ShowCount"

const StyledShowCount = styled(ShowCount)`
  transform: translateY(-5px);
`

export const Styled = {
  StyledShowCount,
}
